var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncentiveRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 72,
    viewBox: "0 0 320 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13517_19102)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 72,
    rx: 16,
    fill: "url(#paint0_linear_13517_19102)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.625,
    width: 318.75,
    height: 70.75,
    rx: 15.375,
    stroke: "url(#paint1_linear_13517_19102)",
    strokeOpacity: 0.3,
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.16,
    cx: 289.5,
    cy: 85.5,
    r: 33.5,
    fill: "url(#paint2_linear_13517_19102)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 72,
    rx: 16,
    fill: "url(#paint3_linear_13517_19102)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_13517_19102)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7926 38C60.9033 38 61.9792 37.8521 63 37.5708C62.188 37.3997 61.3441 37.3098 60.4828 37.3098H46.1394C43.7701 37.3098 41.5603 36.6312 39.6898 35.4567C40.0987 33.0671 41.2239 30.7732 43.0712 28.9288L52.2381 19.7619C53.024 18.976 53.6765 18.1118 54.2043 17.1925C53.5083 17.6449 52.85 18.1785 52.2381 18.7875L42.0939 28.9317C40.4177 30.6079 38.3761 31.6896 36.2243 32.1826C34.8236 30.2019 34 27.7862 34 25.1762V12.2074C34 11.0967 33.8521 10.0208 33.5708 9C33.3997 9.812 33.3098 10.653 33.3098 11.5172V25.8606C33.3098 28.2299 32.6312 30.4397 31.4567 32.3102C29.0671 31.9013 26.7732 30.7761 24.9288 28.9288L15.7619 19.7619C14.976 18.976 14.1118 18.3206 13.1925 17.7957C13.6449 18.4917 14.1785 19.15 14.7875 19.7619L24.9317 29.9061C26.6079 31.5823 27.6896 33.6239 28.1826 35.7757C26.2019 37.1764 23.7862 38 21.1762 38H8.2074C7.0967 38 6.0208 38.1479 5 38.4292C5.812 38.6003 6.653 38.6902 7.5172 38.6902H21.8606C24.2299 38.6902 26.4397 39.3688 28.3102 40.5433C27.9013 42.9329 26.7761 45.2268 24.9288 47.0712L15.7619 56.2381C14.976 57.024 14.3206 57.8882 13.7957 58.8075C14.4917 58.3551 15.15 57.8215 15.7619 57.2125L25.9061 47.0683C27.5823 45.3921 29.6239 44.3104 31.7757 43.8174C33.1764 45.7981 34 48.2138 34 50.8238V63.7897C34 64.9004 34.1479 65.9763 34.4292 66.9971C34.6003 66.1851 34.6902 65.3412 34.6902 64.4799V50.1365C34.6902 47.7672 35.3688 45.5574 36.5433 43.6869C38.9329 44.0958 41.2268 45.221 43.0712 47.0683L52.2381 56.2352C53.024 57.0211 53.8882 57.6736 54.8075 58.2014C54.3551 57.5054 53.8215 56.8471 53.2125 56.2352L43.0683 46.091C41.3921 44.4148 40.3104 42.3732 39.8203 40.2214C41.801 38.8207 44.2167 37.9971 46.8267 37.9971H59.7926V38Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M290.902 60C292.118 61.8201 293.846 62.1724 293.846 62.1724C292.856 62.9273 292.865 63.4306 292.814 64.5461C291.732 64.1016 290.818 63.3886 290.105 62.3653C289.753 61.384 290.105 60.6207 290.91 60.0084L290.902 60Z",
    fill: "#F9D04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.23 3.33594C282.446 5.15607 284.174 5.50835 284.174 5.50835C283.184 6.26325 283.193 6.76651 283.142 7.88207C282.06 7.43753 281.146 6.72457 280.433 5.70127C280.081 4.71991 280.433 3.95663 281.238 3.34433L281.23 3.33594Z",
    fill: "#F9D04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.734 68.6143C233.672 67.5994 234.209 65.9219 234.209 65.9219C234.855 66.9871 235.358 67.0291 236.457 67.2052C235.895 68.2369 235.089 69.0673 233.999 69.6628C232.984 69.906 232.263 69.4867 231.734 68.6143Z",
    fill: "#F9D04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.176 33.4842C220.315 33.9623 221.808 33.0312 221.808 33.0312C221.615 34.2642 221.967 34.6165 222.688 35.4637C221.59 35.8915 220.441 36.0005 219.224 35.7489C218.285 35.2792 218.017 34.4907 218.176 33.4842Z",
    fill: "#B0AFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.978 27.8047C280.093 29.6835 281.796 30.1281 281.796 30.1281C280.764 30.8326 280.756 31.3359 280.639 32.4431C279.582 31.9398 278.701 31.1765 278.055 30.1197C277.753 29.1132 278.139 28.3751 278.978 27.8047Z",
    fill: "#B0AFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.508 44.6724C312.68 44.9408 314.073 43.8672 314.073 43.8672C313.997 45.1086 314.383 45.4273 315.188 46.199C314.14 46.7274 313.007 46.9539 311.766 46.8197C310.793 46.4422 310.441 45.6789 310.508 44.6724Z",
    fill: "#F9D04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.5 12.7428C315.53 13.5648 317.149 12.8937 317.149 12.8937C316.754 14.0764 317.04 14.4874 317.618 15.4352C316.469 15.6701 315.312 15.5946 314.154 15.1416C313.307 14.521 313.173 13.699 313.5 12.7344V12.7428Z",
    fill: "#B0AFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.457 5.74219C248.479 6.57257 250.106 5.90994 250.106 5.90994C249.703 7.09261 249.997 7.50361 250.567 8.4598C249.418 8.69466 248.261 8.61078 247.103 8.14946C246.264 7.52877 246.122 6.69839 246.457 5.74219Z",
    fill: "#F9D04E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M305.274 25.8759C305.342 26.0256 305.479 26.1325 305.64 26.1618L306.679 26.3496C307.086 26.4234 307.233 26.9322 306.926 27.2112L306.143 27.9249C306.022 28.0354 305.963 28.1985 305.985 28.3612L306.126 29.4068C306.181 29.8173 305.742 30.1132 305.382 29.9077L304.465 29.3835C304.322 29.3017 304.147 29.2957 303.999 29.3674L303.048 29.8267C302.675 30.0071 302.257 29.6808 302.341 29.2748L302.556 28.2389C302.59 28.0777 302.542 27.9103 302.428 27.7914L301.7 27.0318C301.414 26.7326 301.595 26.2347 302.006 26.189L303.053 26.073C303.217 26.0549 303.36 25.9579 303.438 25.8135L303.942 24.8803C304.139 24.5162 304.667 24.5348 304.838 24.9117L305.274 25.8759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M238.274 46.8837C238.342 47.0334 238.479 47.1403 238.64 47.1696L239.679 47.3575C240.086 47.4312 240.233 47.94 239.926 48.219L239.143 48.9327C239.022 49.0433 238.963 49.2063 238.985 49.369L239.126 50.4146C239.181 50.8251 238.742 51.121 238.382 50.9155L237.465 50.3913C237.322 50.3096 237.147 50.3035 236.999 50.3752L236.048 50.8345C235.675 51.0149 235.257 50.6886 235.341 50.2827L235.556 49.2467C235.59 49.0855 235.542 48.9181 235.428 48.7992L234.701 48.0399C234.414 47.7406 234.595 47.2426 235.007 47.197L236.058 47.0808C236.222 47.0627 236.366 46.9653 236.444 46.8204L236.943 45.8914C237.139 45.5265 237.668 45.5446 237.839 45.9219L238.274 46.8837Z",
    fill: "#FFB475"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.16,
    cx: 249.5,
    cy: 16.5,
    r: 19.5,
    fill: "url(#paint4_linear_13517_19102)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13517_19102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.659 53.2007L269.307 35.6804L265.395 35.0887L262.993 51.0005L262.99 51.0001C262.99 51.0001 262.985 51.032 262.981 51.0787L262.784 52.3748C262.365 54.6322 261.175 58.8358 258.148 58.3786L269.346 60.0697C266.418 59.6268 266.418 55.5343 266.662 53.2011L266.659 53.2007Z",
    fill: "url(#paint5_radial_13517_19102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.997 14.9601C253.797 15.5434 254.484 16.2878 255.019 17.149C256.372 19.3712 256.319 21.9183 254.86 23.9655C254.292 24.7791 253.474 25.3197 252.541 25.5183C252.12 25.6229 251.668 25.64 251.209 25.5881C249.688 25.4087 248.294 24.4197 247.755 23.126C247.307 22.032 247.483 20.8599 248.251 19.8921C248.758 19.253 249.678 19.1471 250.317 19.651C250.948 20.1508 251.062 21.078 250.558 21.7175C250.431 21.8794 250.45 21.9325 250.473 22.0008C250.588 22.2659 251.045 22.6043 251.539 22.6584C252.069 22.7146 252.318 22.4491 252.462 22.2512C252.487 22.2194 252.509 22.1901 252.526 22.1541C253.378 20.8909 253.034 19.6788 252.648 18.9367C252.596 18.8464 252.549 18.7598 252.498 18.6815C251.524 17.0851 249.581 16.108 247.886 16.3557C245.931 16.6455 244.396 18.5191 243.584 21.6302C242.012 27.6265 245.698 32.3992 248.039 34.7056C250.585 37.2103 253.258 38.7014 255.115 39.3703C256.179 39.7643 256.968 39.8878 257.322 39.7913C258.108 39.5742 258.915 40.0404 259.125 40.8189C259.263 41.2915 259.146 41.7741 258.864 42.1265C258.675 42.3653 258.418 42.5497 258.105 42.6255C257.747 42.7302 257.331 42.7644 256.891 42.739C253.982 42.6358 249.438 40.2254 245.974 36.7949C241.158 32.0415 239.299 26.3928 240.735 20.8853C242.269 15.0462 245.606 13.7093 247.451 13.445C249.361 13.1663 251.39 13.7479 252.995 14.9596L252.997 14.9601Z",
    fill: "url(#paint6_radial_13517_19102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.378 19.7885C285.435 20.0922 284.55 20.5847 283.776 21.2351C281.795 22.9228 281.048 25.3573 281.79 27.7598C282.075 28.709 282.682 29.4801 283.505 29.9604C283.871 30.191 284.294 30.35 284.748 30.4454C286.25 30.7523 287.881 30.247 288.801 29.1888C289.567 28.2917 289.766 27.1231 289.34 25.9613C289.061 25.1962 288.216 24.8073 287.454 25.087C286.698 25.3646 286.3 26.2117 286.579 26.9738C286.649 27.1672 286.613 27.2122 286.572 27.2684C286.381 27.4861 285.841 27.662 285.353 27.5586C284.831 27.4473 284.678 27.1175 284.603 26.8819C284.59 26.8446 284.575 26.8069 284.572 26.768C284.158 25.3004 284.862 24.2583 285.465 23.6745C285.543 23.6031 285.612 23.5362 285.685 23.4788C287.109 22.2663 289.261 21.9488 290.794 22.7126C292.561 23.599 293.433 25.8606 293.23 29.0691C292.846 35.2586 287.849 38.6344 284.905 40.0905C281.704 41.6719 278.698 42.2497 276.724 42.306C275.589 42.3451 274.8 42.2158 274.498 42.0153C273.821 41.5651 272.907 41.7517 272.466 42.4269C272.185 42.8326 272.149 43.3271 272.303 43.7517C272.407 44.0358 272.594 44.2907 272.868 44.4635C273.175 44.6736 273.559 44.8359 273.986 44.9511C276.78 45.765 281.853 44.899 286.214 42.7231C292.278 39.7181 295.808 34.9347 296.172 29.2539C296.542 23.2279 293.794 20.9127 292.122 20.0845C290.396 19.2246 288.288 19.1403 286.384 19.7865L286.378 19.7885Z",
    fill: "url(#paint7_radial_13517_19102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.953 17.4248C284.953 17.4248 284.81 18.4744 284.47 20.1816C283.134 26.9395 278.726 44.08 268.025 47.5766L267.479 47.9201C266.789 48.3493 265.954 48.503 265.156 48.3576L264.663 48.2683C263.963 48.14 263.331 47.788 262.85 47.2717L262.348 46.7226C253.274 40.2982 253.995 22.9949 254.707 15.9512C254.901 14.0661 255.086 12.9132 255.086 12.9132C255.338 11.2377 257.367 11.0917 257.367 11.0917L283.296 15.0137C283.296 15.0137 285.203 15.7489 284.951 17.4244L284.953 17.4248Z",
    fill: "url(#paint8_linear_13517_19102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.095 19.4276L256.258 15.3736C254.614 15.1261 253.475 13.5798 253.723 11.9361C253.971 10.2925 255.517 9.15386 257.16 9.40141L283.998 13.4554C285.642 13.7029 286.78 15.2492 286.533 16.8929C286.285 18.5365 284.739 19.6751 283.095 19.4276Z",
    fill: "#F8BD36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.095 19.4276L256.258 15.3736C254.614 15.1261 253.475 13.5798 253.723 11.9361C253.971 10.2925 255.517 9.15386 257.16 9.40141L283.998 13.4554C285.642 13.7029 286.78 15.2492 286.533 16.8929C286.285 18.5365 284.739 19.6751 283.095 19.4276Z",
    fill: "#FFB127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.095 19.4276L256.258 15.3736C254.614 15.1261 253.475 13.5798 253.723 11.9361C253.971 10.2925 255.517 9.15386 257.16 9.40141L283.998 13.4554C285.642 13.7029 286.78 15.2492 286.533 16.8929C286.285 18.5365 284.739 19.6751 283.095 19.4276Z",
    fill: "url(#paint9_linear_13517_19102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.922 59.1458L274.114 62.3479C275.176 62.5084 275.908 63.5009 275.748 64.5628L274.026 75.9602L248.988 72.1771L250.71 60.7796C250.871 59.7177 251.863 58.9858 252.925 59.1462L252.922 59.1458Z",
    fill: "url(#paint10_radial_13517_19102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.718 74.0353L247.923 69.8354C247.754 69.8098 247.596 69.9264 247.57 70.0958L247.34 71.6235C247.314 71.7929 247.431 71.951 247.6 71.9766L275.395 76.1764C275.564 76.202 275.722 76.0855 275.748 75.9161L275.979 74.3883C276.004 74.2189 275.888 74.0608 275.718 74.0353Z",
    fill: "#FFB127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.718 74.0353L247.923 69.8354C247.754 69.8098 247.596 69.9264 247.57 70.0958L247.34 71.6235C247.314 71.7929 247.431 71.951 247.6 71.9766L275.395 76.1764C275.564 76.202 275.722 76.0855 275.748 75.9161L275.979 74.3883C276.004 74.2189 275.888 74.0608 275.718 74.0353Z",
    fill: "url(#paint11_radial_13517_19102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.986 64.6712L256.17 62.5835C255.665 62.5072 255.193 62.8547 255.117 63.3597L254.427 67.9256C254.351 68.4305 254.698 68.9018 255.203 68.9781L269.02 71.0658C269.525 71.1421 269.996 70.7945 270.072 70.2896L270.762 65.7237C270.838 65.2187 270.491 64.7475 269.986 64.6712Z",
    fill: "url(#paint12_linear_13517_19102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.786 60.1368L257.7 58.3106C257.578 58.2922 257.465 58.3758 257.446 58.4973L257.281 59.591C257.263 59.7124 257.346 59.8258 257.468 59.8441L269.554 61.6703C269.675 61.6887 269.789 61.6051 269.807 61.4837L269.972 60.3899C269.991 60.2685 269.907 60.1552 269.786 60.1368Z",
    fill: "#FFB127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.786 60.1368L257.7 58.3106C257.578 58.2922 257.465 58.3758 257.446 58.4973L257.281 59.591C257.263 59.7124 257.346 59.8258 257.468 59.8441L269.554 61.6703C269.675 61.6887 269.789 61.6051 269.807 61.4837L269.972 60.3899C269.991 60.2685 269.907 60.1552 269.786 60.1368Z",
    fill: "url(#paint13_radial_13517_19102)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13517_19102",
    x: 1,
    y: 5,
    width: 66,
    height: 65.9961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_13517_19102"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13517_19102",
    x: 236.262,
    y: 7.36719,
    width: 63.9439,
    height: 74.8125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13517_19102"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13517_19102",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13517_19102",
    x1: 8,
    y1: 43.0541,
    x2: 261.329,
    y2: 151.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA7059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13517_19102",
    x1: 62.3377,
    y1: -4.5,
    x2: 83.3429,
    y2: 82.4598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13517_19102",
    x1: 297,
    y1: 41.5,
    x2: 286,
    y2: 73.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13517_19102",
    x1: 123,
    y1: 26.5,
    x2: 203.329,
    y2: 81.5539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566508,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13517_19102",
    x1: 249.5,
    y1: -3,
    x2: 249.5,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_13517_19102",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(270.739 38.6164) rotate(108.726) scale(21.7932 11.8479)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDAC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB375"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_13517_19102",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(259.322 18.072) rotate(114.961) scale(25.8889 21.6896)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDAC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB375"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_13517_19102",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(293.799 23.1324) rotate(115.508) scale(25.6553 22.113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDAC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_13517_19102",
    x1: 282,
    y1: 23,
    x2: 284.62,
    y2: 39.4092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCEB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_13517_19102",
    x1: 283.498,
    y1: 10.5039,
    x2: 285.319,
    y2: 21.9914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDAC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB375"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_13517_19102",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(272.043 63.5711) rotate(135.105) scale(14.873 21.6516)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDAC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB375"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_13517_19102",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(271.713 73.6769) rotate(177.76) scale(10.223 5.74465)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDAC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB375"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_13517_19102",
    x1: 278.092,
    y1: 61.6283,
    x2: 270.456,
    y2: 74.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA9E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_13517_19102",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(268.094 60.058) rotate(171.326) scale(4.63618 4.00029)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0AD76"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13517_19102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 72,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncentiveRewards);
export default __webpack_public_path__ + "static/media/IncentiveRewards.c69cef12049f22c25e4af9f030f3e440.svg";
export { ForwardRef as ReactComponent };